import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';
import HeaderDos from '../../Metodos/Compartidos/HeaderDos.js';
import { TablaPacientes } from './TablaPacientes.js';

// css
import { Cuerpo } from '../../Css/StyledHeader.js';
import { FlexLanding } from '../../Css/StyledLanding.js';
import { BotonPacienteDos } from '../../Css/StyledPatient.js';

import { cargarPacientesAction } from '../../../actions/cargarPacientesActions.js';
import { solicitoSuscripcionProfesionalAction } from '../../../actions/cargarSuscripcionActions.js';

import useConfigAuth from '../../../Hooks/useConfigAuth.js';


const Pacientes = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [config] = useConfigAuth();

    const pacientes = useSelector((state) => state.informacion.lista_pacientes);
    const infoSuscripcion = useSelector((state) => state.usuario.suscripcion);

    const estadoSuscripcion = infoSuscripcion?.estado_suscripcion;


    useEffect(() => {

        const informacion = {
            config
        };

        // La suscripción se consulta independientemente
        // de que ya tengamos pacientes cargados en Redux.
        dispatch(solicitoSuscripcionProfesionalAction(informacion));

        // Evitamos pedir nuevamente los pacientes si
        // ya están disponibles en el store.
        if (pacientes.length === 0) {
            dispatch(cargarPacientesAction(informacion));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const irSuscripcion = (e) => {
        e.preventDefault();
        navigate("/escritorio/misuscripcion");
    };


    return (
        <Cuerpo>
            <HeaderUno />
            <HeaderDos
                componente={"Listado pacientes"}
                paciente={false}
            />

            <TablaPacientes
                pacientes={pacientes}
                config={config}
            />

            {estadoSuscripcion?.[0] &&
                !estadoSuscripcion[0].prueba_gratis && (

                    <FlexLanding
                        justify="center"
                        align="center"
                        margin="2rem 0 0 0"
                    >
                        <BotonPacienteDos
                            style={{
                                backgroundColor: "yellow",
                                fontWeight: "bold"
                            }}
                            onClick={irSuscripcion}
                        >
                            Ir a Activar Demo Gratis
                        </BotonPacienteDos>
                    </FlexLanding>
                )}

        </Cuerpo>
    );
};


export default Pacientes;